import { gql } from "@apollo/client";

export const GET_ALL_COMPLEJIDAD = gql`
query GetAllComplejidad {
    allComplejidad{
            idComplejidad,
            descripcion,
            abreviacion
      }
}`;